<ng-template #loading>
    <app-mat-spinner-overlay text="Vent litt..."></app-mat-spinner-overlay>
</ng-template>

<div *ngIf="data; else loading" class="flex-column flex-gap-20">

    <div class="flex-column">
        <h1 *ngIf="declined === false && caseId !== null">{{getLabelValue('Title') | striphtml}}</h1>
        <h1 *ngIf="declined === false && caseId === null">{{getLabelValue('TitleInvalid') | striphtml}}</h1>
        <h1 *ngIf="declined === true && caseId === null">{{getLabelValue('TitleDeclined') | striphtml}}</h1>

        <div *ngIf="contactInvitationType === 0 && declined === false && caseId !== null" [innerHtml]="getLabelValue('ContactInvitationText') | safe: 'html'"></div>
        <div *ngIf="contactInvitationType === 1 && declined === false && caseId !== null" [innerHtml]="getLabelValue('ComplainerInvitationText') | safe: 'html'"></div>
        
        <div *ngIf="declined === false && caseId === null" [innerHtml]="getLabelValue('ContactInvitationTextInvalid') | safe: 'html'"></div>
        <div *ngIf="declined === true && caseId === null" [innerHtml]="getLabelValue('FeedbackDeclined') | safe: 'html'"></div>

    </div>

    <div class="flex-column" *ngIf="declined === false && caseId !== null">
        <mat-form-field class="pin-input">
            <mat-label>PIN</mat-label>
            <input matInput (keyup.enter)="approveContactInvitation()" (keypress)="numberOnly($event)" [(ngModel)]="PINCode" autocomplete="off" maxlength="6">
            <mat-hint>PIN kode 6 siffer</mat-hint>
        </mat-form-field>
        <div class="error-text-wrapper">
            <mat-error *ngIf="invalidPin">PIN er ugyldig</mat-error>
        </div>
    </div>

    <div class="flex-row flex-gap-20" *ngIf="declined === false && caseId !== null">
        <button style="flex: 0 1 150px" mat-raised-button color="primary" class="finkn-btn"
            (click)="approveContactInvitation()" type="button">{{getLabelValue('ContactInvitationButtonYes') |
            striphtml}}</button>
        <button style="flex: 0 1 150px" mat-raised-button color="primary" class="finkn-btn"
            (click)="denyContactInvitation()" type="button">{{getLabelValue('ContactInvitationButtonNo') |
            striphtml}}</button>
    </div>


</div>